<template>
  <div class="form-group with-icon-left">
    <div class="input-group">
      <input
        onpaste="return false;"
        autocomplete="off"
        id="fl-input-icon-left"
        title=" "
        name="fl-input-icon-left"
        @keyup.enter="doUputnica($event)"
        v-model="uputnicaText"
        required
      >
      <i class="glyphicon glyphicon-search icon-left input-icon search-icon"></i>
      <label class="control-label" for="fl-input-icon-left">{{'Uputnica'}}</label>
      <i class="bar"></i>
    </div>
  </div>
</template>

<script>
import { bus } from "../../../main";
export default {
  name: "uputnicaBar",
  data() {
    return {
      uputnicaText: ""
    };
  },
  mounted() {
    bus.$on("Uputnica", data => {
      this.uputnicaText = data;
    });
  },
  beforeDestroy() {
    bus.$off("Uputnica");
  },
  methods: {
    doUputnica(event) {
      this.$emit("uputnica", this.uputnicaText, event);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-icon {
  transform: rotate(90deg);
}

.form-group {
  min-width: 7rem;
}

@media (max-width: 768px) {
  .form-group {
    width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/02_prijem/datatable-components/UputnicaBar.vue